const SERVERCONFIG = {
  url: 'https://fuka-lager.de/api/',
  withCredentials: true
}

export default SERVERCONFIG

